export default [
    "VRadioGroup2",
    "VRadio2",
    "VCarouselSwiper",
    "MyAutocomplete",
    "IconBtn",
    "IconSvg/IconSvg",
    "VProgressCircular2",
    "MySnackbar",
    "Img/VBluredImg",
    "Img/VImg",
    "VSkeleton",
    "VSwitch",
    "VCardList",
    "VCard",
    "VSection",
    "Input/ui/VInput",
	"Modal/ui/VModal",
	"Button/ui/VButton",
	"Tag/VTag",
	"Tag/VTags",
    "GradualText/ui/VGradualText",
    "GradualText/ui/VNestedElements",
]